import { useContext } from 'react';
import { EngagementContext } from 'shared/providers/engagementProvider/EngagementProvider';

export const useEngagement = () => {
  const context = useContext(EngagementContext);
  if (!context) {
    throw new Error('useEngagement must be used within a EngagementProvider');
  }
  return context;
};
